/* eslint-disable */
import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import PropTypes from 'prop-types';
import styles from './scopeFE.module.scss';

const FilterOptionRadioGroup = ({ options, value, onChange, label, disabled }) => {
  return (
    <div className={styles['ScopeFE-gridItem']}>
      <div className={styles['ScopeFE-gridItem-heading']}>{label}</div>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(e, newValue) => {
          if (newValue !== null) {
            onChange(e, newValue);
          }
        }}
        disabled={disabled}
        className={styles.toggleButtonGroup}
      >
        {options.map((option) => (
          <ToggleButton
            key={option.id}
            value={option.id}
            className={`${styles.toggleButton} ${value === String(option.id) ? styles.selected : ''}`}
           
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

FilterOptionRadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool, 
};

export default FilterOptionRadioGroup;